import VenueMap from 'components/V2/VenueMap';
import React from 'react';
import { connect } from 'react-redux';
import {
  addContact,
  addEquipment,
  clearContacts,
  clearEquipment,
  contactUpdated,
  equipmentUpdated,
  fetchFireDeptSuccess,
  fetchHospitalSuccess,
  fetchPoliceSuccess,
  mapUpdated,
  removeContact,
  removeEquipment,
  fieldChange,
} from 'redux/ducks/Post/EAP/actions';
import EmergencyServices from 'scenes/CreateEventScene/CreateEventStep3/EAPForm/EmergencyServices';
import ContactList from './ContactList';
import EmergencyEquipment from './EmergencyEquipment';

const GenerateEAP = (props) => {
  const onHospitalChange = (hospital) => {
    props.dispatch(fetchHospitalSuccess({ hospital }));
  };

  const onFireDeptChange = (fireDepartment) => {
    props.dispatch(fetchFireDeptSuccess({ fireDepartment }));
  };

  const onPoliceChange = (policeStation) => {
    props.dispatch(fetchPoliceSuccess({ policeStation }));
  };

  const onMapLoad = (map) => {
    props.dispatch(mapUpdated({ map }));
  };

  const onAddContact = () => props.dispatch(addContact());
  const onRemoveContact = (index) => props.dispatch(removeContact({ index }));
  const onChangeContact = (index, contact) => props.dispatch(contactUpdated({ index, contact }));
  const clearAllContacts = () => props.dispatch(clearContacts());

  const onAddEquipment = (name = '') => props.dispatch(addEquipment({ name }));
  const onRemoveEquipment = (index) => props.dispatch(removeEquipment({ index }));
  const onChangeEquipment = (index, equipment) =>
    props.dispatch(equipmentUpdated({ index, equipment }));
  const clearEquipments = () => props.dispatch(clearEquipment());

  const onInstructionsChange = (ev) => {
    const { value } = ev.currentTarget;
    props.dispatch(fieldChange({ name: 'instructions', value }));
  };

  const { form, wasValidated } = props;

  return (
    <div className="generateEAP">
      <VenueMap onMapLoad={onMapLoad} imageSrc={form.venueMapUrl} />
      <EmergencyServices
        hospital={form.hospital}
        policeStation={form.policeStation}
        fireDepartment={form.fireDepartment}
        onHospitalChange={onHospitalChange}
        onFireDeptChange={onFireDeptChange}
        onPoliceChange={onPoliceChange}
      />
      <ContactList
        wasValidated={wasValidated}
        contacts={form.emergencyContacts}
        addContact={onAddContact}
        removeContact={onRemoveContact}
        changeContact={onChangeContact}
        clearContacts={clearAllContacts}
      />
      <EmergencyEquipment
        wasValidated={wasValidated}
        equipmentList={form.emergencyEquipment}
        onChange={onChangeEquipment}
        addEquipment={onAddEquipment}
        removeEquipment={onRemoveEquipment}
        clearEquipment={clearEquipments}
      />
      <div className="section-header gotham-bold-font col facility">Facility Specific Instructions</div>
      <div className='nimbus-regular-font'>
        <p className="sub-text">
          Add safety instructions. This may include additional details on AED location, ambulance
          access points, lightning-safe shelters, inclement weather plans, etc.
        </p>
        <textarea
          onChange={onInstructionsChange}
          value={form.instructions || ''}
          type="text"
          className="form-control italic-placeholder"
          placeholder="Add safety instructions specific to the facility/venue."
        />
      </div>
    </div>
  );
};

const mapStateToProps = (state) => {
  const currentForm = state.post.eap.currentForm;
  const form = state.post.eap.forms[currentForm];
  const { locationIdx } = state.post.navigation;
  const shiftLocation = state.post.locations[locationIdx];

  return { forms: state.post.eap.forms, form, shiftLocation, locationIdx };
};

const mapDispatchToProps = (dispatch) => ({
  dispatch,
});

export default connect(mapStateToProps, mapDispatchToProps)(GenerateEAP);
